
import React from 'react';

interface SvgIconProps {
  src: string;
  width?: number;
  height?: number;
  alt?: string;
  className?: string;
}

const SvgIcon = ({
  src,
  width = 36,
  height,
  alt = "",
  className,
  ...restProps
}: SvgIconProps) => {
  return (
    <img 
      src={src}
      width={width}
      height={height}
      alt={alt}
      className={className}
      {...restProps}
    />
  );
};

export { SvgIcon };